import { useContext, useMemo } from 'react';
import { I18nextContext, useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql, useStaticQuery } from 'gatsby';

import generateWatchProjectImage from '../../utils/generateWatchProjectImage';
import { BUYING_PRODUCTS_ROUTE } from '../../utils/routes/const';
import ProductCard from '../ProductCard';
import { I18NextContext } from 'gatsby-plugin-react-i18next/dist/types';

const prodQuery = graphql`
query {
  salesWatches: allSalesWatch(limit: 4) {
    nodes {
      imagePath
      watch {
        referenceNumber
        brand {
          name
        }
        model {
          name
        }
      }
      slug
      price
      priceOnDemand
    }
  }
}`;

type StaticMostPopularProductsSalesWatch = {
  imagePath: string;
  watch: {
    referenceNumber: string;
    brand: {
      name: string;
    };
    model: {
      name: string;
    };
  };
  slug: string;
  price: number;
  priceOnDemand: boolean;
}

type StaticMostPopularProductsQuery = {
  salesWatches: {
    nodes: StaticMostPopularProductsSalesWatch[];
  };
};


const mapDataToProductCard = (localeContext: I18NextContext, product: StaticMostPopularProductsSalesWatch) => {
  const numberFormatter = Intl.NumberFormat(localeContext.language, { style: 'currency', currency: 'EUR', currencyDisplay: 'symbol' });

  return {
    title: `${product.watch.brand.name} ${product.watch.model?.name || ''} (${product.watch.referenceNumber})`,
    priceOnDemand: product.priceOnDemand,
    price: numberFormatter.format(product.price),
    image: generateWatchProjectImage(product.imagePath, product.watch.referenceNumber),
    link: BUYING_PRODUCTS_ROUTE(product.slug.replace(/^\/|\/$/g, '')),
    className: 'flex flex-col',
  };
}

const MostPopularProducts = ({ title = 'products.mostPopular' }: { title?: string }) => {
  const { t } = useTranslation();
  const { salesWatches } = useStaticQuery<StaticMostPopularProductsQuery>(prodQuery);
  const localeContext = useContext(I18nextContext);

  const results = useMemo(() => salesWatches.nodes.map((result: StaticMostPopularProductsSalesWatch) => mapDataToProductCard(localeContext, result)), [salesWatches])

  return (
    <section className="py-12 pt-12 px-4 max-w-screen-2xl w-full mx-auto">
      <h2 className="px-20 lg:px-0 text-center font-cirka text-xl mb-6">{t(title)}</h2>
      <div className="grid xl:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-6 lg:gap-4">
        {results.map((product) => (
          <ProductCard key={product.title} type="buy" priceStyle="text-base" {...product} />
        ))}
      </div>
    </section>
  )
}

export default MostPopularProducts;
